import React from 'react';
import ModuleWeekForm from '../../../../components/forms/ModuleWeekForm';

export default function ModulesWeeksCreatePage() {
  return <ModuleWeekForm />;
}
